export default __webpack_public_path__ + "static/media/discord.40d6af01.svg";